import {
  type GlobalBannerQuery,
  type OrganizationDataForFailedPaymentBanner,
} from '../../generated/graphql';
import {type Org} from '../../util/accounts/pricing';
import {type Account} from '../Search/SearchNav/types';
import {type BlockedRegionBannerProps} from './BlockedRegionBanners/utils';
import {type FreeAccountEnforcementBannerFlags} from './FreeAccountEnforcementBanners/utils';
import {type StorageBannerFlags} from './StorageEnforcementBanners/utils';
import {type WeaveEnforcementBannerFlags} from './WeaveEnforcementBanners/types';

export type ViewerOrgs = NonNullable<
  GlobalBannerQuery['viewer']
>['organizations'];
export type ViewerOrg = ViewerOrgs[number];

export enum LegacyNudgeBarType {
  StandardComputeHours = 'standard-compute-hours',
  AdvancedComputeHours = 'advanced-compute-hours',
  EnterpriseToStandard = 'enterprise-to-standard',
  EnterpriseToAdvanced = 'enterprise-to-advanced',
  UpgradeNudgeBarForExpiringSubscription = 'upgrade-nudge-bar-for-expiring-subscription',
  ContactUsNudgeBarForExpiringSubscription = 'contact-us-nudge-bar-for-expiraing-subscription',
  ExpiredSubscriptionEnforcementWithUpgrade = 'expired-subscription-enforcement-with-upgrade',
  ExpiredSubscriptionEnforcementWithContactUs = 'expired-subscription-enforcement-with-contact-us',
  DisabledSubscriptionEnforcement = 'disabled-subscription-enforcement',
}

export type LegacyNudgeBarInfo = {
  type: LegacyNudgeBarType;
  maxComputeHours?: number;
  aggressive?: boolean;
  daysUntilEnforcement?: number;
};

export type GlobalBannerState = {
  account: Account;

  // legacy stuff

  /** @deprecated pls use account to match appropriate state */
  organization: Org | null;
  renderedNudgeBar: LegacyNudgeBarType | null;
  maxHours: number | null;
  aggressive?: boolean;
  daysUntilEnforcement?: number;

  // new way of retrieving banner information
  storageAndEnforcementBannerFlags: StorageBannerFlags;
  failedPaymentOrgData: OrganizationDataForFailedPaymentBanner | null;
  freeAccountEnforcementBannerFlags: FreeAccountEnforcementBannerFlags;
  disabledSubscriptionBannerFlags: boolean;
  blockedRegionBannerProps: BlockedRegionBannerProps;
  weaveEnforcementBannerFlags: WeaveEnforcementBannerFlags;
};

export type GlobalBannerStates = {
  states: GlobalBannerState[] | null;
};
